export default {
  currentUser: {
    typeAddanceTimeKepping: null,
    dataConfigSystem: null,
    dataConfigPurposes: null,
    dataConfigService: null,
    dataConfigMcc: null,
    dataConfigCCRP: null,
    dataConfigLocation: null,
    dataConfigRegion: null,
    depositType: null
  }
}
